module.exports = __webpack_public_path__ + "static/team-shraddha-thakur-57d865c5f68afad1df249fab00eed4e6.jpeg";